(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    const SUBSCRIPTION_PITCH_MARKERS = [
    'wil je harmony structureel',
    'would you like to incorporate harmony',
    'abonnement vanaf de aankoop van 60 capsules',
    'subscription starting from the purchase of 60 capsules',
  ];

  const removeSubscriptionPitchFromDescription = (descriptionBlock) => {
    const content = descriptionBlock.querySelector('[data-product-description-content]');
    if (!content) return;

    for (const element of content.querySelectorAll('p, li, div')) {
      const text = element.textContent?.toLowerCase().trim() || '';
      if (!text) continue;

      if (SUBSCRIPTION_PITCH_MARKERS.some((marker) => text.includes(marker))) {
        element.remove();
      }
    }
  };

  const parseLengthToPx = (value) => {
    const trimmed = (value || '').trim();
    if (!trimmed) return 84;

    if (trimmed.endsWith('rem')) {
      const rootFont = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      return parseFloat(trimmed) * rootFont;
    }

    if (trimmed.endsWith('px')) {
      return parseFloat(trimmed);
    }

    return parseFloat(trimmed) || 84;
  };

  const initProductDescriptionCollapsible = (scope = document) => {
    const descriptionBlocks = scope.querySelectorAll('.product-description-block');

    for (const descriptionBlock of descriptionBlocks) {
      const isHarmonyProduct = descriptionBlock.dataset.productHandle === 'harmony';

      if (!isHarmonyProduct) {
        removeSubscriptionPitchFromDescription(descriptionBlock);
      }

      const content = descriptionBlock.querySelector('[data-product-description-content]');
      const toggle = descriptionBlock.querySelector('[data-product-description-toggle]');
      const label = descriptionBlock.querySelector('[data-product-description-toggle-label]');

      if (!content || !toggle || !label) continue;

      const showMoreLabel = toggle.dataset.showMoreLabel || 'Show more';
      const showLessLabel = toggle.dataset.showLessLabel || 'Show less';

      descriptionBlock.classList.remove('product-description-block--collapsible');
      descriptionBlock.classList.remove('product-description-block--expanded');
      toggle.setAttribute('aria-expanded', 'false');
      label.textContent = showMoreLabel;
      toggle.hidden = true;

      const collapsedHeight = parseLengthToPx(
        getComputedStyle(content).getPropertyValue('--pdp-description-collapsed-height')
      );
      const shouldCollapse = content.scrollHeight > collapsedHeight + 8;

      if (!shouldCollapse) continue;

      descriptionBlock.classList.add('product-description-block--collapsible');
      toggle.hidden = false;

      toggle.onclick = () => {
        const isExpanded = descriptionBlock.classList.toggle('product-description-block--expanded');
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        label.textContent = isExpanded ? showLessLabel : showMoreLabel;
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductDescriptionCollapsible();
    });
  } else {
    initProductDescriptionCollapsible();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductDescriptionCollapsible(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
